module.exports = __webpack_public_path__ + "static/img/img.a60637a3.jpg";